<template>
  <div class="UserSelector selector">
    <lm-avatar :src="avatarSrc" @click.native="$refs.select.$refs.search.focus">
    </lm-avatar>
    <v-select
      ref="select"
      :value="value"
      :options="userList"
      :label="label"
      :placeholder="placeholder"
      :max-height="maxHeight"
      @input="$emit('input', $event)"
    >
    </v-select>
    <button v-if="value" class="DeleteButton" @click="$emit('input', null)">
      <i class="material-icons">delete</i>
    </button>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import LmAvatar from '@/components/ui/LmAvatar'

export default {
  name: 'LmUserSelector',
  components: {
    LmAvatar,
    vSelect
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    userList: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: null
    },
    maxHeight: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  computed: {
    avatarSrc() {
      return this.value ? this.value.picture : ''
    }
  }
}
</script>

<style>
.UserSelector {
  display: flex;
  align-items: center;
  .DeleteButton {
    color: grey;
  }
  .LmAvatar {
    cursor: pointer;
  }
  .v-select {
    width: 280px;
    margin: 0 10px;
    input {
    }
    .selected-tag {
      background-color: white;
      border: none;
      border-radius: 0;
      margin: 0;
      padding: 0;
    }
  }
}
</style>
